import { rescaleAndEnsureInteger } from "./rescaleAndEnsureInteger.js";
import { vectorEncoder } from "./vectorEncoder.js";
export function xyDataCreator(data, options = {}) {
    const { xyEncoding = 'DIF' } = options;
    const { xFactor = 1, yFactor = 1 } = options.info || {};
    const firstX = data.x[0];
    const lastX = data.x.at(-1);
    const firstY = data.y[0];
    const lastY = data.y.at(-1);
    const nbPoints = data.x.length;
    const deltaX = (lastX - firstX) / (nbPoints - 1);
    const lines = [
        `##FIRSTX=${firstX}`,
        `##LASTX=${lastX}`,
        `##FIRSTY=${firstY}`,
        `##LASTY=${lastY}`,
        `##DELTAX=${deltaX}`,
        `##XFACTOR=${xFactor}`,
        `##YFACTOR=${yFactor}`,
        '##XYDATA=(X++(Y..Y))',
    ];
    const line = vectorEncoder(rescaleAndEnsureInteger(data.y, yFactor), firstX / xFactor, deltaX / xFactor, xyEncoding);
    if (line)
        lines.push(line);
    return lines;
}
//# sourceMappingURL=xyDataCreator.js.map